import React from "react";
import { FormControl, Input, InputLabel, ListItemText, MenuItem, Select } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: "100%",
    maxWidth: 300,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
}));

export const MultiSelectClientes = ({ list, handleChange, value, labelName, disabled }) => {
  const classes = useStyles();

  return (
    <>
      <FormControl className={clsx(classes.formControl, classes.noLabel)}>
        <InputLabel>{labelName}</InputLabel>
        <Select
          value={value}
          onChange={handleChange}
          input={<Input />}
          inputProps={{ "aria-label": "Without label" }}
          renderValue={(selected) => {
            if (!selected) {
              return "";
            }
          
            const selectedItem = list.find((item) => item.id === selected);
            return selectedItem ? selectedItem.nombre : "";
          }}
        >
          {list.map((item, index) => (
            <MenuItem key={index} value={item.id}>
              <ListItemText primary={item.nombre} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};
